/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { HandleMessageResponseJson } from './handle-message-response-json';
import { HandleMessageResult } from '../results/handle-message-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CaseManagementUserDto } from '../models/case-management-user-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class HandleMessageResponse extends ResponseWithErrorGeneric<HandleMessageResponseJson, HandleMessageResult> implements IResponseWithErrorGeneric<HandleMessageResult> {
  public caseId: string = undefined;
  public messageId: string = undefined;
  public handler: CaseManagementUserDto;
  public handledUtc: Date | string;

  //<custom-body>
  constructor(response: HttpResponse<HandleMessageResponse>) {
    super(response, HandleMessageResult.Error);
    if (this.result === HandleMessageResult.Success) {
      this.caseId = this.body.caseId;
      this.messageId = this.body.messageId;
      this.handledUtc = this.body.handledUtc;

      if (this.body.handler)
        this.handler = new CaseManagementUserDto(this.body.handler);
    }
  }
  //</custom-body>
}
